import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import StarfallPage from './pages/StarfallPage';
import MinesweeperPage from './pages/MinesweeperPage';
import SnakesPage from './pages/SnakesPage';
import "jbeat-ui/style";
import Games2026 from './pages/Games2026';
var App = function () {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "/", element: React.createElement(HomePage, null) }),
        React.createElement(Route, { path: "/2026", element: React.createElement(Games2026, null) }),
        React.createElement(Route, { path: "/starfall", element: React.createElement(StarfallPage, null) }),
        React.createElement(Route, { path: "/minesweeper", element: React.createElement(MinesweeperPage, null) }),
        React.createElement(Route, { path: "/snakes", element: React.createElement(SnakesPage, null) })));
};
export default App;
